import { render } from "./EOIDetails.vue?vue&type=template&id=ece6f158&scoped=true&ts=true&lang=pug"
import script from "./EOIDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./EOIDetails.vue?vue&type=script&lang=ts&setup=true"

import "./EOIDetails.vue?vue&type=style&index=0&id=ece6f158&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece6f158"]])

export default __exports__